import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchBilledAdsWtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchBilledAdsWtd = (filters: FetchBilledAdsWtdProps) => void;

const fetchBilledAdsWtd = ({
  startDate,
  endDate,
  report,
}: FetchBilledAdsWtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };

  await fetchReport(report, dispatch, params);
};

export default fetchBilledAdsWtd;
